var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.904 2.292a1 1 0 0 1 1.338.069l5 5a1 1 0 0 1-1.415 1.414l-3.293-3.293v15.482a1.001 1.001 0 0 1-2 0V5.482L8.243 8.775A1 1 0 1 1 6.827 7.36l5-5z"
  })));
};
export default Svg24;